module.exports = "/_next/static/images/history-empty-fd67a475.png";